// extracted by mini-css-extract-plugin
export default {"root":"Login_root__Mv9xp","card":"Login_card__UpnCW"};